var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_ALL_ADDRESSES_REQUEST, fetchAllAddressesFailure, fetchAllAddressesSuccess } from '../../actions';
import API from '../../../utils/API';
const onFetchAllAddresses = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const userId = action.payload;
            API.get(`onbd/company/address/all`)
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchAllAddressesWorker(action) {
    try {
        const data = yield call(onFetchAllAddresses, action);
        yield put(fetchAllAddressesSuccess(data));
    }
    catch (error) {
        yield put(fetchAllAddressesFailure(error));
    }
}
export function* watchAllAddressesData() {
    yield takeLatest(FETCH_ALL_ADDRESSES_REQUEST, fetchAllAddressesWorker);
}
